// Utilities
import isEmpty from './isEmpty'
import { CookieConstants, ErrorTypes } from '../constants'

class SessionUtil {
  static getIdToken () {
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = window.sessionStorage.key(i)
      if (key.includes('idToken')) {
        return sessionStorage.getItem(key)
      }
    }
    return null
  }

  static getAccessToken () {
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = window.sessionStorage.key(i)
      if (key.includes('accessToken')) {
        return sessionStorage.getItem(key)
      }
    }
    return null
  }

  static getDeviceKey () {
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = window.sessionStorage.key(i)
      if (key.includes('deviceKey')) {
        return sessionStorage.getItem(key)
      }
    }
    return null
  }

  static setNetworkErrorCookie (errorMessage, isNetworkError = false) {
    const profileId = errorMessage.split(':')[1]
    const unixTime = errorMessage.split(ErrorTypes.profileLocked)[1]

    let unlockDate
    let minutes

    if (!isEmpty(unixTime) || unixTime.includes('undefined')) {
      const unlockProfileTime = Number.parseInt(unixTime) * 1000
      const milliseconds = Math.abs(new Date() - unlockDate)

      unlockDate = new Date(unlockProfileTime)
      minutes = Math.ceil(milliseconds / 60000)
    }

    const cookieObj = {
      isNetworkError,
      date: unlockDate,
      profileId
    }

    SessionUtil.setCookie(CookieConstants.networkError, JSON.stringify(cookieObj), minutes)
  }

  static setCookie (cname, cvalue, minutes) {
    const d = new Date()
    d.setTime(d.getTime() + minutes * 60 * 1000)
    const expireTime = d.toUTCString()

    const domain = SessionUtil.getDomain()

    document.cookie = `${cname}=${cvalue};expires=${expireTime};domain=${domain};path=/`
  }

  static getCookie (cname) {
    const name = `${cname}=`
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return null
  }

  static deleteCookie (cname) {
    const d = new Date()
    d.setTime(d.getTime() - 1)
    const expireTime = d.toUTCString()

    const domain = SessionUtil.getDomain()

    document.cookie = `${cname}=;expires=${expireTime};domain=${domain};path=/`
  }

  /**
   * Clears all Cognito identity session items. If multiple usernames sign in during the same session, multiple items are created which can cause issues retrieving auth and ID tokens.
   */
  static clearIdentitySessions () {
    for (let i = 0; i < window.sessionStorage.length; i++) {
      const key = window.sessionStorage.key(i)
      if (key.includes('CognitoIdentityServiceProvider')) {
        window.sessionStorage.removeItem(key)
      }
    }

    return null
  }

  static getDomain () {
    if (window.location.host.includes('localhost')) {
      return 'localhost'
    }

    if (window.location.host.includes('amazonaws')) {
      return '.com.s3.amazonaws.com'
    }

    if (window.location.host.includes('cloudfront')) {
      // Being used for the backward compatibility site
      return window.location.hostname.split('.')[0] + '.cloudfront.net'
    }

    return `.${location.hostname.split('.').reverse()[1]}.${location.hostname.split('.').reverse()[0]}`
  }

  static async wait (milliseconds) {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
  }

  static hasIncompleteOrigination (customerId) {
    const originationCookie = SessionUtil.getCookie(CookieConstants.origination.key + customerId)
    return !isEmpty(originationCookie)
  }
}

export default SessionUtil
